import theme from "../tailwind-theme";

import { useWindowSize as _useWindowSize } from "usehooks-ts";

const useWindowSize = () => {
  const { width } = _useWindowSize();

  const isMobile = width < (parseInt(theme.screens.md) || 768);

  return {
    width,
    isMobile,
  };
};

export default useWindowSize;
